const map = {
	"./shared/benchmarks/benchmark-percentile-chart/index.js": [
		49414,
		[
			2528,
			1284,
			2316,
			9414
		]
	],
	"./shared/benchmarks/benchmarks-list/index.js": [
		70920,
		[
			7700,
			2528,
			2316,
			920
		]
	],
	"./shared/benchmarks/benchmarks-selector/index.js": [
		59051,
		[
			2528,
			1284,
			2316,
			7621,
			9051
		]
	],
	"./shared/benchmarks/config/index.js": [
		31965,
		[
			1284,
			1965
		]
	],
	"./shared/benchmarks/hooks/index.js": [
		75000,
		[
			5000
		]
	],
	"./shared/benchmarks/screens/index.js": [
		51016,
		[
			1284,
			1016
		]
	],
	"./shared/benchmarks/simple-store/index.js": [
		2649,
		[
			2649
		]
	],
	"./shared/copy-to-clipboard/index.js": [
		66258,
		[
			2316,
			6258
		]
	],
	"./views/index.js": [
		97612,
		[]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map((id) => (__webpack_require__.e(id)))).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 86864;
module.exports = webpackAsyncContext;